import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const serviceImages = [
  "https://customer-assets.emergentagent.com/job_design-showcase-1404/artifacts/25b96a0d_DSC02594.webp",
  "https://customer-assets-jai6qajn.emergentagent.net/job_design-showcase-1404/artifacts/aj71xc85_4_Photo%20-%2011_Photo%20-%2016.webp",
  "https://customer-assets.emergentagent.com/job_design-showcase-1404/artifacts/t7385p9a_DSC02636.webp",
];

const reveal = {
  hidden: { opacity: 0, y: 60 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

const HEAD_INIT = { opacity: 0, y: 40 };
const HEAD_SHOW = { opacity: 1, y: 0 };
const VP_ONCE = { once: true };
const HEAD_T = { duration: 0.9 };
const VP_80 = { once: true, margin: "-80px" };

export const Services = () => {
  const { t } = useLanguage();
  const items = t("services.items");
  const services = serviceImages.map((img, i) => ({
    num: `0${i + 1}`,
    img,
    title: items[i].title,
    desc: items[i].desc,
  }));
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 sm:py-40 bg-[#0B1622]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={HEAD_INIT}
          whileInView={HEAD_SHOW}
          viewport={VP_ONCE}
          transition={HEAD_T}
          className="max-w-2xl mb-20"
        >
          <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-6">
            {t("services.eyebrow")}
          </p>
          <h2 className="font-serif-lux text-4xl sm:text-5xl lg:text-6xl leading-tight text-white">
            {t("services.title")} <span className="gold-gradient-text italic">{t("services.titleAccent")}</span>
          </h2>
        </motion.div>

        <div className="space-y-10">
          {services.map((s, i) => (
            <motion.div
              key={s.num}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={VP_80}
              data-testid={`service-card-${s.num}`}
              className={`grid grid-cols-1 md:grid-cols-12 gap-8 items-center group ${
                i % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
            >
              <div className="md:col-span-7 overflow-hidden [direction:ltr]">
                <div className="relative overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="w-full h-[420px] object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-[#0A1420]/20 group-hover:bg-transparent transition-colors duration-700" />
                </div>
              </div>
              <div className="md:col-span-5 [direction:ltr]">
                <span className="font-serif-lux text-7xl sm:text-8xl text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.4)]">
                  {s.num}
                </span>
                <h3 className="font-serif-lux text-3xl sm:text-4xl text-white mt-4">
                  {s.title}
                </h3>
                <p className="mt-5 text-[#A0ABC0] font-light leading-relaxed max-w-md">
                  {s.desc}
                </p>
                <button
                  onClick={() =>
                    document.querySelector("#consultation")?.scrollIntoView({ behavior: "smooth" })
                  }
                  data-testid={`service-cta-${s.num}`}
                  className="mt-8 text-[#D4AF37] text-sm uppercase tracking-widest border-b border-[#D4AF37]/40 pb-1 hover:border-[#D4AF37] transition-colors duration-300"
                >
                  {t("services.cta")}
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
